"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CloseRound2_exports = {};
__export(CloseRound2_exports, {
  default: () => CloseRound2_default
});
module.exports = __toCommonJS(CloseRound2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.457 10.25L12.9023 11.6953C13.0456 11.8255 13.1172 11.9883 13.1172 12.1836C13.1172 12.3659 13.0456 12.5221 12.9023 12.6523C12.7721 12.7956 12.6094 12.8672 12.4141 12.8672C12.2318 12.8672 12.0755 12.7956 11.9453 12.6523L10.5 11.207L9.05469 12.6523C8.92448 12.7956 8.76172 12.8672 8.56641 12.8672C8.38411 12.8672 8.22786 12.7956 8.09766 12.6523C7.95443 12.5221 7.88281 12.3659 7.88281 12.1836C7.88281 11.9883 7.95443 11.8255 8.09766 11.6953L9.54297 10.25L8.09766 8.80469C7.95443 8.67448 7.88281 8.51823 7.88281 8.33594C7.88281 8.14062 7.95443 7.97786 8.09766 7.84766C8.22786 7.70443 8.38411 7.63281 8.56641 7.63281C8.76172 7.63281 8.92448 7.70443 9.05469 7.84766L10.5 9.29297L11.9453 7.84766C12.0755 7.70443 12.2318 7.63281 12.4141 7.63281C12.6094 7.63281 12.7721 7.70443 12.9023 7.84766C13.0456 7.97786 13.1172 8.14062 13.1172 8.33594C13.1172 8.51823 13.0456 8.67448 12.9023 8.80469L11.457 10.25ZM5.1875 15.5625C4.45833 14.8203 3.91146 13.987 3.54688 13.0625C3.18229 12.151 3 11.2135 3 10.25C3 9.28646 3.18229 8.34896 3.54688 7.4375C3.91146 6.51302 4.45833 5.67969 5.1875 4.9375C5.92969 4.20833 6.76302 3.66146 7.6875 3.29688C8.59896 2.93229 9.53646 2.75 10.5 2.75C11.4635 2.75 12.401 2.93229 13.3125 3.29688C14.237 3.66146 15.0703 4.20833 15.8125 4.9375C16.5417 5.67969 17.0885 6.51302 17.4531 7.4375C17.8177 8.34896 18 9.28646 18 10.25C18 11.2135 17.8177 12.151 17.4531 13.0625C17.0885 13.987 16.5417 14.8203 15.8125 15.5625C15.0703 16.2917 14.237 16.8385 13.3125 17.2031C12.401 17.5677 11.4635 17.75 10.5 17.75C9.53646 17.75 8.59896 17.5677 7.6875 17.2031C6.76302 16.8385 5.92969 16.2917 5.1875 15.5625ZM6.16406 14.5859C6.76302 15.1849 7.4401 15.6341 8.19531 15.9336C8.95052 16.2331 9.71875 16.3828 10.5 16.3828C11.2812 16.3828 12.0495 16.2331 12.8047 15.9336C13.5599 15.6341 14.237 15.1849 14.8359 14.5859C15.4349 13.987 15.8841 13.3099 16.1836 12.5547C16.4831 11.7995 16.6328 11.0312 16.6328 10.25C16.6328 9.46875 16.4831 8.70052 16.1836 7.94531C15.8841 7.1901 15.4349 6.51302 14.8359 5.91406C14.237 5.3151 13.5599 4.86589 12.8047 4.56641C12.0495 4.26693 11.2812 4.11719 10.5 4.11719C9.71875 4.11719 8.95052 4.26693 8.19531 4.56641C7.4401 4.86589 6.76302 5.3151 6.16406 5.91406C5.5651 6.51302 5.11589 7.1901 4.81641 7.94531C4.51693 8.70052 4.36719 9.46875 4.36719 10.25C4.36719 11.0312 4.51693 11.7995 4.81641 12.5547C5.11589 13.3099 5.5651 13.987 6.16406 14.5859Z",
      fill: "currentColor"
    }
  )
);
const SvgCloseRound2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CloseRound2_default = SvgCloseRound2;
